import React from 'react';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { Skeleton, Stack } from '@mui/material';
import { useStyles } from './style';
import ActionModalBodyDescription from './ActionModalBodyDescription';

/**
 * @name ActionModalBody - Action Modal Body
 * @param {object} props - CMS data from collection type Eir Action Modal
 * @returns {JSX.Element} - Body of the Action Modal
 */
const ActionModalBody = props => {
  const theme = useTheme();
  const style = useStyles(theme);

  return (
    <>
      {props.load && (
        <Stack sx={{ width: '100%' }}>
          <Skeleton height={50} width='80%' sx={{ m: '0 auto' }} />
          <Skeleton height={20} width='80%' sx={{ m: '0 auto' }} />
        </Stack>
      )}
      {!props.load && props.title && (
        <Typography variant='h3' sx={style.modalheaderstyle}>
          {props.title}
        </Typography>
      )}
      <ActionModalBodyDescription description={props.description} />
    </>
  );
};

ActionModalBody.displayName = 'ActionModalBody';
export default ActionModalBody;
